var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`link-${_vm.mainArticlePortal}`,{tag:"div",class:{ 'teaser-link': _vm.teaserlink },attrs:{"article":_vm.article}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm.article.attributes.title)+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }